import React from 'react';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import Loading from 'Components/Loading';
import ApplicationLayout from 'Components/ApplicationLayout';
import pMinDelay from 'p-min-delay';

const Coupons = loadable(() => pMinDelay(import('./Coupons'), 300), {
  fallback: <Loading />
});

const AsyncCoupons = props => {
  const pageConfig = {
    headerType: 'full',
    footerType: props.userAgent.device?.type === 'desktop' ? 'full' : 'mobile-none',
    loadGameListFull: true,
    helmet: {
      bodyAttributes: {
        class: `${ props.userAgent.device?.type } bg-green`
      }
    }
  };

  return (
    <ApplicationLayout { ...pageConfig } { ...props }>
      <Coupons { ...props }/>
    </ApplicationLayout>
  );
};

AsyncCoupons.propTypes = {
  userAgent: PropTypes.object
};

export default AsyncCoupons;
